export const ORG_NAME_MIN_LENGTH = 2
export const ORG_NAME_MAX_LENGTH = 120
export const ORG_DESCRIPTION_MAX_LENGTH = 500
export const ORG_DISPLAY_NAME_MAX_LENGTH = 120
export const ORG_CONTACT_EMAIL_MAX_LENGTH = 320
/** Max E.164 length per ITU-T E.164 (including leading +). */
export const ORG_CONTACT_PHONE_MAX_LENGTH = 16
export const ORG_WEBSITE_URL_MAX_LENGTH = 500

export const CONTACT_LEAD_ORG_NAME_MAX_LENGTH = 200
export const CONTACT_LEAD_CONTACT_NAME_MAX_LENGTH = 120
export const CONTACT_LEAD_MESSAGE_MAX_LENGTH = 2000
